'use client';
import React, { useContext, useId } from 'react';
import useMemoObject from './useMemoObject';

// OptionsContext is responsible for providing all static options
// recommended for those which are needed in different places
// e.g. if hideSelected is set than selected items will
// - hide the according shape in the chart/graph
// - make the according legend icon half opaque

const OptionsContext = React.createContext<any>(() => false);

export const OptionsContextProvider = ({ children, hideSelected }: any) => {
  const chartId = useId();
  const value = useMemoObject({ hideSelected, chartId });

  return <OptionsContext.Provider value={value}>{children}</OptionsContext.Provider>;
};
export const useOptionsContext = () => useContext(OptionsContext); // constant
